import { Overlay } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { ReactComponent as SaveTripIllustration } from '@eti/assets/illustrations/default/saved-trip.svg';
import { Heading, Inline, Stack } from '@etg/wings';
import type { TripDataType } from '../../../../common/custom-hooks/save-trips/models';
import { SavedTripCard } from './drawer/saveTrip/SavedTripCard';

const informationWrapper = css`
  padding: 16px;
`;

export interface SaveTripDrawerProps {
  closeSavedTripDrawer: () => void;
  isSavedTripDrawerOpen: boolean;
  removeSavedTrip: (tripKey: string) => void;
  savedTrips: TripDataType[];
}

const SaveTripDrawer = ({
  closeSavedTripDrawer,
  isSavedTripDrawerOpen,
  removeSavedTrip,
  savedTrips,
}: SaveTripDrawerProps) => {
  const { t } = useTranslation();

  return (
    <Overlay.Drawer
      dataTestId="save-trip-button-drawer"
      handleClose={closeSavedTripDrawer}
      isOpen={isSavedTripDrawerOpen}
    >
      <Overlay.Header onClose={closeSavedTripDrawer} title={t('Result.SaveTrip.Header.Text')} />
      <Overlay.Content>
        {savedTrips.length ? (
          <Stack className={informationWrapper} spacing={4}>
            <Heading level={3}>{t('Result.SavedTrips.Title.Text')}</Heading>
            <p>{t('Result.SavedTrips.Information.Text')}</p>
          </Stack>
        ) : (
          <Stack className={informationWrapper} spacing={16}>
            <Heading level={3}>{t('Result.NoSavedTrips.Title.Text')}</Heading>
            <p>{t('Result.NoSavedTrips.Information.Text')}</p>
            <Inline align="center">
              <SaveTripIllustration />
            </Inline>
          </Stack>
        )}
        {savedTrips.map((trip) => (
          <SavedTripCard key={trip.selectionKey} removeSavedTrip={removeSavedTrip} trip={trip} />
        ))}
      </Overlay.Content>
    </Overlay.Drawer>
  );
};
export default SaveTripDrawer;
